export default __webpack_public_path__ + "static/media/chooose.67299e02.svg";